import knightsConstantRedux from "../constant";
const initialSetting = {
  services: [],
  main_price: 0,
  main_currency: { label: "usd", value: "$" },
  coins: [
    {
      label: "usd",
      value: "$",
      price: 0,
      operator: "multiplication",
      main: true,
    },
  ],
  product_fileds: [],
  charges_type: [],
  delimiter: "|",
  barcode_fields: [],
  lira_round: 5000,
  expire_period: 5,
  card_settings: {
    cardWidth: 100,
    cardHeight: 100,
    fontSize: 12,
    imageSize: 70,
  },
  integrationConfig: {
    enableSync: false,
    websiteUrl: "",
    apiKey: "",
  },
  invoiceTemplates: [],
  currentInvoiceTemplate: null,
  pricing_mode: 'profit',
  profit_type: 'fixed',
  default_min_profit_pct: 0,
  default_max_profit_pct: 0,
  default_sale_type: 'percent',
};
const appSetting = (state = initialSetting, action, root) => {
  switch (action.type) {
    case knightsConstantRedux.EDIT_MAIN_PRICE:
      return {
        ...state,
        main_price: action.payload.mainPrice,
      };
    case knightsConstantRedux.EDIT_COMMISSION:
      return {
        ...state,
        commission: action.payload.commission,
      };
    case knightsConstantRedux.EDIT_lira_round:
      return {
        ...state,
        lira_round: action.payload.liraRound,
      };
    case knightsConstantRedux.EDIT_MAIN_CURRENCY:
      return {
        ...state,
        main_currency: action.payload.mainCurrency,
      };

    case knightsConstantRedux.EDIT_COINS:
      return {
        ...state,
        coins: state.coins.map((co) => {
          if (
            co.value === action.payload.editCurrency.value ||
            co.label === action.payload.editCurrency.label
          ) {
            co = action.payload.editCurrency;
          }
          return co;
        }),
      };
    case knightsConstantRedux.DELETE_COINS:
      return {
        ...state,
        coins: state.coins.filter(
          (co) => co.value !== action.payload.deleteCurrency.value
        ),
      };
    case knightsConstantRedux.SET_COINS_LIST:
      return {
        ...state,
        coins: action.payload.coinsList,
      };
    case knightsConstantRedux.ADD_COINS_ITEM:
      return {
        ...state,
        coins: [...state.coins, action.payload.currency],
      };
    case knightsConstantRedux.EDIT_PRODUCT_FIELDS:
      // let productIndex = state.product_fileds.findIndex(pro => pro.field === action.payload.productField.field);
      // state.product_fileds[productIndex] = action.payload.productField;
      return {
        ...state,
        product_fileds: state.product_fileds.map((pf) => {
          if (pf.field === action.payload.productField.field) {
            pf.deleted = action.payload.productField.deleted;
          }
          return pf;
        }),
      };
    case knightsConstantRedux.CHANGE_PRODUCT_POSITION:
      const beforeDataIndex = state.product_fileds.findIndex(
        (spf) => spf.field === action.payload.productFieldBefore
      );
      const afterDataIndex = state.product_fileds.findIndex(
        (spf) => spf.field === action.payload.productFieldAfter
      );
      const beforeData = state.product_fileds[beforeDataIndex];
      state.product_fileds[beforeDataIndex] =
        state.product_fileds[afterDataIndex];
      state.product_fileds[afterDataIndex] = beforeData;
      return {
        ...state,
        product_fileds: state.product_fileds,
      };
    case knightsConstantRedux.SET_PRODUCT_FIELDS:
      return {
        ...state,
        product_fileds: action.payload.productFields,
      };
    case knightsConstantRedux.SET_SERVICE_LIST:
      return {
        ...state,
        services: action.payload.serviceList,
      };
    case knightsConstantRedux.EDIT_SERVICE:
      let index = state.services.findIndex(
        (sl) => sl.value === action.payload.service.value
      );
      state.services[index] = action.payload.service;
      return {
        ...state,
        services: state.services,
      };
    case knightsConstantRedux.ADD_TO_SERVICE_LIST:
      return {
        ...state,
        services: [...state.services, action.payload.service],
      };
    case knightsConstantRedux.SET_CHARGES_TYPE_LIST:
      return {
        ...state,
        charges_type: action.payload.chargesTypeList,
      };
    case knightsConstantRedux.ADD_CHARGE_TYPE:
      return {
        ...state,
        charges_type: [...state.charges_type, action.payload.chargesType],
      };
    case knightsConstantRedux.EDIT_CHARGE_TYPE:
      let indexType = state.charges_type.findIndex(
        (ct) => ct.value === action.payload.chargesType.value
      );
      state.charges_type[indexType] = action.payload.chargesType;
      return {
        ...state,
        charges_type: state.charges_type,
      };
    case knightsConstantRedux.EDIT_EXPIRE_PERIOD:
      return {
        ...state,
        expire_period: action.payload.expirePeriod,
      };
    case knightsConstantRedux.DELETE_CHARGE_TYPE:
      return {
        ...state,
        charges_type: state.charges_type.filter(
          (ch) => ch.value !== action.payload.chargesType.value
        ),
      };
    case knightsConstantRedux.GET_MAIN_CURRENCY:
      return state.main_currency;
    case knightsConstantRedux.GET_COINS:
      return state.coins;
    case knightsConstantRedux.EDIT_DELIMITER:
      return {
        ...state,
        delimiter: action.payload.value,
      };
    case knightsConstantRedux.ADD_BARCODE_FIELD:
      const product = state.barcode_fields.find(
        (bf) => bf.field === action.payload.value.field
      );
      if (!product) {
        return {
          ...state,
          barcode_fields: [...state.barcode_fields, action.payload.value],
        };
      }
      return state;
    case knightsConstantRedux.DELETE_BARCODE_FIELD:
      return {
        ...state,
        barcode_fields: state.barcode_fields.filter(
          (bf) => bf.field !== action.payload.value.field
        ),
      };

    case knightsConstantRedux.SET_VIEW_SETTINGS:
      return {
        ...state,
        card_settings: action.payload.viewSettings,
      };
case knightsConstantRedux.SET_INTEGRATION_CONFIG:
      return {
        ...state,
        integrationConfig: action.payload.integrationConfig,
      };

    case knightsConstantRedux.SET_PRICING_CONFIG:
      return {
        ...state,
        pricing_mode: action.payload.pricing_mode,
        profit_type: action.payload.profit_type,
        default_min_profit_pct: action.payload.default_min_profit_pct,
        default_max_profit_pct: action.payload.default_max_profit_pct,
        default_sale_type: action.payload.default_sale_type,
      };

    case knightsConstantRedux.SET_INVOICE_TEMPLATES:
      return {
        ...state,
        invoiceTemplates: action.payload.invoiceTemplates,
      };

    case knightsConstantRedux.ADD_INVOICE_TEMPLATE:
      return {
        ...state,
        invoiceTemplates: [...(state.invoiceTemplates || []), action.payload.invoiceTemplate],
      };

    case knightsConstantRedux.UPDATE_INVOICE_TEMPLATE:
      return {
        ...state,
        invoiceTemplates: (state.invoiceTemplates || []).map(tpl =>
          tpl.id === action.payload.invoiceTemplate.id ? action.payload.invoiceTemplate : tpl
        ),
      };

    case knightsConstantRedux.DELETE_INVOICE_TEMPLATE:
      return {
        ...state,
        invoiceTemplates: (state.invoiceTemplates || []).filter(
          tpl => tpl.id !== action.payload.templateId
        ),
      };

    case knightsConstantRedux.SET_CURRENT_INVOICE_TEMPLATE:
      return {
        ...state,
        currentInvoiceTemplate: action.payload.currentTemplate,
      };

    default:
      return state;
  }
};
export default appSetting;
